// routing
import IdleSessionMonitor from './ui-component/IdleSessionMonitor';
import Routes from './routes';

// project imports
import NavigationScroll from './layout/NavigationScroll';
import ThemeCustomization from './themes';
import { ToastContainer } from 'react-toastify';
import { initializeAuth } from './store/slices/auth/auth-api';
import { useEffect, useRef } from 'react';
import { useAppDispatch } from './hooks/useAppDispatch';
import createCache from '@emotion/cache';
import { CacheProvider } from '@emotion/react';

// ==============================|| APP ||============================== //

const App = () => {
    const dispatch = useAppDispatch();
    const didInitRef = useRef(false);
    const cacheRtl = createCache({
        key: 'css',
        prepend: true,
        stylisPlugins: []
    });

    useEffect(() => {
        if (didInitRef.current) {
            return;
        }
        didInitRef.current = true;
        dispatch(initializeAuth());
    }, [dispatch]);
    return (
        <ThemeCustomization>
            <CacheProvider value={cacheRtl}>
                <NavigationScroll>
                    <>
                        <Routes />
                        <IdleSessionMonitor />
                        <ToastContainer hideProgressBar />
                    </>
                </NavigationScroll>
            </CacheProvider>
        </ThemeCustomization>
    );
};

export default App;
